import { colorsPalettes } from "@similarweb/styles";
import { Box, Stack, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import AIAgentTrackingService from "app/pages/sales-intelligence/modules/ai-agent/services/tracking/trackingService";
import type { Competitor } from "app/pages/sales-intelligence/modules/ai-agent/types/meeting";
import { CompetitorItem } from "app/pages/sales-intelligence/pages/ai-agent/components/CompetitorItem/CompetitorItem";
import {
    CompetitorsAutocomplete,
    MAX_COMPETITORS,
} from "app/pages/sales-intelligence/pages/ai-agent/components/CompetitorsAutocomplete/CompetitorsAutocomplete";

type EmailCompetitorsProps = {
    value: Competitor[];
    onChange: (value: Competitor[]) => void;
};

export const EmailCompetitors = ({ value, onChange }: EmailCompetitorsProps) => {
    const handleAddCompetitor = (competitor: Competitor) => {
        onChange(Array.from(new Set([...(value ?? []), competitor])));
        AIAgentTrackingService.email.trackAddCompetitor(competitor.domain);
    };

    const handleRemoveCompetitor = (competitorDomain: string) => {
        const newValue = value?.filter(({ domain }) => domain !== competitorDomain);
        AIAgentTrackingService.email.trackRemoveCompetitor(competitorDomain);
        onChange(newValue);
    };

    return (
        <Stack
            margin="16px 0"
            data-automation="competitors-container"
        >
            <Text
                color={colorsPalettes.carbon[400]}
                fontVariant="sectionTitle"
                margin="0 0 16px"
            >
                {translate("si.pages.ai_agent.form.competitors.title")}
            </Text>
            <CompetitorsAutocomplete
                value={value}
                onAddCompetitor={handleAddCompetitor}
                placeholder={`${translate("si.pages.ai_agent.form.competitors.placeholder.search")} (${value?.length ?? 0}/${MAX_COMPETITORS})`}
                searchIcon="search"
                disabled={value?.length >= MAX_COMPETITORS}
            />
            <Box margin="12px 0 0" />
            <Stack>
                {value?.map((competitor) => (
                    <CompetitorItem
                        competitor={competitor}
                        key={competitor.domain}
                        onRemoveCompetitor={handleRemoveCompetitor}
                    />
                ))}
            </Stack>
        </Stack>
    );
};
